import { render, staticRenderFns } from "./associatedOrganizationTable.vue?vue&type=template&id=ef0fba78&scoped=true&"
import script from "./associatedOrganizationTable.vue?vue&type=script&lang=js&"
export * from "./associatedOrganizationTable.vue?vue&type=script&lang=js&"
import style0 from "./associatedOrganizationTable.vue?vue&type=style&index=0&id=ef0fba78&prod&scoped=true&lang=css&"
import style1 from "./associatedOrganizationTable.vue?vue&type=style&index=1&id=ef0fba78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0fba78",
  null
  
)

export default component.exports